import api from '@/utils/api'

let state = {
  count: 0,
  polls: []
}

let actions = {
  refresh (ctx) {
    api.get('pollToAnswer').then((response) => {
      ctx.state.polls = response.data.polls
      ctx.state.count = response.data.count
    }).catch(() => {
    })
  },
  clean (ctx) {
    ctx.state.polls = []
    ctx.state.count = 0
  }
}

let getters = {
  eventsAndPollsToAnswer (state) {
    return state.polls.map((p) => p.event ? p.event : p)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/toAnswer.js